import { action } from "easy-peasy";

const AppStoreModel = {
  loading: false,
  breadcrumbs: [],
  setLoading: action((state, payload) => {
    state.loading = payload;
  }),
  setBreadcrumbs: action((state, payload) => {
    state.breadcrumbs = payload;
  }),
  updateBreadcrumb: action((state, payload) => {
    const crumbs = [...state.breadcrumbs];
    crumbs[crumbs.length - payload.index] = payload.object;
    state.breadcrumbs = crumbs;
  }),
};

export default AppStoreModel;
